import { cloudflareImagesLoader } from "@talladega/helpers";
import Image, { ImageProps } from "next/image";

type Props = Omit<ImageProps, "loader">;

const baseDomain = process.env.NEXT_PUBLIC_CLOUDFLARE_IMAGES_DOMAIN || "";

const nextImageLoader = ({ src, width }: { src: string; width: number }) =>
  cloudflareImagesLoader({ src, width, baseDomain });

const CloudflareImagesImage = ({ src, ...props }: Props) => {
  // eslint-disable-next-line react/forbid-elements
  return <Image src={src} loader={nextImageLoader} {...props} />;
};

export default CloudflareImagesImage;
